var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbx2024Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2092.58 1070.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #9295b7;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M287.33,374.29c-7.54-11.85-3.43-27.63,8.96-34.26,248.19-132.75,1012.25-466.05,1760.85,189.98,23.43,20.53,6.14,46.82-25.14,18.29C1291.4-127.15,416.19,301.01,311.61,378.79c-7.86,5.85-19.02,3.76-24.28-4.5h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 666.2,
    y: 128.29,
    width: 35.14,
    height: 112.29,
    rx: 17.57,
    ry: 17.57
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 676.49,
    y: 128.29,
    width: 35.14,
    height: 112.29,
    rx: 17.57,
    ry: 17.57
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 823.07,
    y: 94.86,
    width: 35.14,
    height: 112.29,
    rx: 17.57,
    ry: 17.57
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 833.35,
    y: 94.86,
    width: 35.14,
    height: 112.29,
    rx: 17.57,
    ry: 17.57
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 978.22,
    y: 84.57,
    width: 35.14,
    height: 112.29,
    rx: 17.57,
    ry: 17.57
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 988.5,
    y: 84.57,
    width: 35.14,
    height: 112.29,
    rx: 17.57,
    ry: 17.57
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1115.36,
    y: 94,
    width: 35.14,
    height: 112.29,
    rx: 17.57,
    ry: 17.57
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1125.65,
    y: 94,
    width: 35.14,
    height: 112.29,
    rx: 17.57,
    ry: 17.57
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1262.8,
    y: 120.57,
    width: 35.14,
    height: 112.29,
    rx: 17.57,
    ry: 17.57
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1273.08,
    y: 120.57,
    width: 35.14,
    height: 112.29,
    rx: 17.57,
    ry: 17.57
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.59,710.97l-57.22,244.9H84.14l105.87-451.95c28.8-123.19,98.34-184.79,208.63-184.79h360.05l-34.25,146.94h-360.05c-19.46,0-32.18,12.62-38.15,37.85l-14.01,60.11h389.24l-34.64,146.94h-389.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M773.62,319.13h360.05c87.71,0,131.56,38.89,131.56,116.66,0,20.19-2.99,42.9-8.95,68.13l-5.06,22.26c-11.16,46.61-27.51,83.71-49.05,111.32,3.89,12.47,5.84,26.72,5.84,42.75,0,19.89-2.99,42.74-8.95,68.57l-5.45,22.26c-28.8,123.19-98.35,184.79-208.64,184.79h-360.44l149.08-636.74ZM817.99,710.97l-22.96,97.96h223.82c19.72,0,32.56-12.61,38.53-37.85l5.45-22.26c1.29-5.64,1.94-10.69,1.94-15.14,0-15.14-7.65-22.71-22.96-22.71h-223.82ZM852.25,564.03h224.21c19.72,0,32.56-12.61,38.53-37.85l5.06-22.26c1.29-5.93,1.95-11.13,1.95-15.58,0-14.84-7.53-22.26-22.58-22.26h-223.82l-23.35,97.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1364.83,637.5l-114.83-318.37h156.86l66.95,186.12,154.14-186.12h156.87l-263.52,318.37,114.44,318.37h-156.87l-66.95-186.12-154.14,186.12h-156.87l263.91-318.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbx2024Dark);
export default __webpack_public_path__ + "static/media/FBX_2024_dark.5fe48a1fedb341a96f22815d44186ae9.svg";
export { ForwardRef as ReactComponent };